import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import moment from 'moment'

// components
import { CButton, CImage } from '@coreui/react-pro'
import AppCard from '../../components/AppCard'
import AppTable from 'src/components/AppTable'
import AppModalConfirmation from 'src/components/modal/AppModalConfirmation'

// icons
import AddMoreIconWhite from '../../assets/icons/AddMoreIconWhite.png'

// styling
import { styleButtonVars2 } from '../../components/custom-styles/buttonStyles'

// helpers
import Axios from '../../helpers/axios'
import { columnTimeOffBalanceList } from '../../components/table-column/TableColumnList'
import { formUrlQuery } from '../../helpers/format-queries'
import useToastMessage from 'src/helpers/toast-message'

const TimeOffBalanceList = () => {
  const navigate = useNavigate()
  const { showSuccess, showError } = useToastMessage();

  const [showConfirmDelete, setShowConfirmDelete] = useState({ show: false, item: {} })

  const [timeOffBalanceList, setTimeOffBalanceList] = useState(null);
  const [timeOffBalanceListCount, setTimeOffBalanceListCount] = useState(0);
  const [timeOffBalanceListPerPage, setTimeOffBalanceListPerPage] = useState(10);
  const [activeTimeOffBalanceListPage, setActiveTimeOffBalanceListPage] = useState(1);
  const [searchTimeOffBalanceListFilter, setSearchTimeOffBalanceListFilter] = useState("");
  const [columnTimeOffBalanceListSorter, setColumnTimeOffBalanceListSorter] = useState({ column: "updatedAt", state: "desc" });

  useEffect(() => {
    let queries = {
      search: searchTimeOffBalanceListFilter,
      limit: timeOffBalanceListPerPage,
      offset: timeOffBalanceListPerPage * activeTimeOffBalanceListPage - timeOffBalanceListPerPage,
      sort:
        (columnTimeOffBalanceListSorter &&
          `${columnTimeOffBalanceListSorter.column}%${columnTimeOffBalanceListSorter.state}`) ||
        "",
    };
    queries = formUrlQuery(queries);
    fetchAllTimeOffBalances(queries);
  }, [
    searchTimeOffBalanceListFilter,
    timeOffBalanceListPerPage,
    activeTimeOffBalanceListPage,
    columnTimeOffBalanceListSorter,
  ]);

  const handleSearchItems = (search) => {
    setActiveTimeOffBalanceListPage(1)
    setSearchTimeOffBalanceListFilter(search);
  }

  const fetchAllTimeOffBalances = (queries) => {
    Axios({
      method: "get",
      url: `/api/tracker/v1/leave/balance/all?${queries}`
    })
      .then(({ data }) => {
        let tempTimeOffBalanceList = data?.value
        tempTimeOffBalanceList = tempTimeOffBalanceList.map((item) => {
          return {
            ...item,
            employee_name: item?.employee?.first_name + ' ' + item?.employee?.last_name,
            employee_status: item?.employee?.status ? `${item?.employee?.status}` : '-',
            accrued_balance: item?.accrued_balance ? `${item?.accrued_balance} Days` : '-',
            used_balance: item?.used_balance ? `${item?.used_balance} Days` : '-',
            available_balance: item?.available_balance ? `${item?.available_balance} Days` : '-',
            updatedAt: item?.updatedAt ? moment(item?.updatedAt).format('YYYY-MM-DD') : '-',
          }
        }) || []
        setTimeOffBalanceList(tempTimeOffBalanceList);
        if (activeTimeOffBalanceListPage === 1) {
          setTimeOffBalanceListCount(data?.count);
        }
      })
      .catch((err) => {
        console.error(err);
        const errMsg = err?.response?.data?.message
        showError(errMsg)
      });
  };

  const handleDeleteConfirmation = () => {
    Axios({
      method: "delete",
      url: `/api/tracker/v1/leave/balance/delete/${showConfirmDelete?.item?.id}`,
    })
      .then(({ data }) => {
        if (data?.success) {
          setShowConfirmDelete({ show: false, item: {} })
          fetchAllTimeOffBalances(formUrlQuery({
            search: searchTimeOffBalanceListFilter,
            limit: timeOffBalanceListPerPage,
            offset: timeOffBalanceListPerPage * activeTimeOffBalanceListPage - timeOffBalanceListPerPage,
            sort:
              (columnTimeOffBalanceListSorter &&
                `${columnTimeOffBalanceListSorter.column}%${columnTimeOffBalanceListSorter.state}`) ||
              "",
          }))
          showSuccess('Time-off balance has been successfully deleted')
          window.location.reload()
        }
      })
      .catch((err) => {
        console.error(err);
        const errMsg = err?.response?.data?.message
        showError(errMsg)
      });
  }

  const handleOnRowClick = (item, columnName) => {
    if (columnName !== 'action') {
      navigate(`/time-off-balance/details/${item.id}`)
    }
  }

  return (
    <>
      {
        showConfirmDelete?.show && (
          <AppModalConfirmation
            confirmationType='delete-item'
            itemName={`Time-Off Balance - ${showConfirmDelete?.item?.employee_name}`}
            itemDetails={showConfirmDelete.item}
            itemType={showConfirmDelete.type}
            itemIndex={showConfirmDelete?.index}
            showModal={showConfirmDelete}
            setShowModal={setShowConfirmDelete}
            handleConfirmation={handleDeleteConfirmation}
          />
        )
      }
      <div className='d-grid gap-2 d-md-flex justify-content-md-end mb-3'>
        <CButton style={styleButtonVars2} onClick={() => navigate('/time-off-balance/add')}>
          <CImage fluid src={AddMoreIconWhite} className='me-2' />
          Add Time-Off Balance
        </CButton>
      </div>
      <AppCard
        className='mb-4'
        headerTitle={<h4>Time-Off Balance List</h4>}
        bodyContent={
          <AppTable
            timeOffBalanceListPage
            tableFilter
            setShowConfirmDelete={setShowConfirmDelete}
            tableColumns={columnTimeOffBalanceList}
            tableContent={timeOffBalanceList}
            contentPerPage={timeOffBalanceListPerPage}
            activeContentPage={activeTimeOffBalanceListPage}
            contentCount={timeOffBalanceListCount}
            searchContentFilter={searchTimeOffBalanceListFilter}
            setActiveContentPage={setActiveTimeOffBalanceListPage}
            setSearchContentFilter={handleSearchItems}
            setContentPerPage={setTimeOffBalanceListPerPage}
            setColumnContentSorter={setColumnTimeOffBalanceListSorter}
            handleOnRowClick={handleOnRowClick}
            isClickable={true}
          />
        }
      />
    </>
  )
}

export default TimeOffBalanceList
